import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PortalAuthProvider } from './auth/PortalAuth'
import App from './App'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A customer's own freight changes on the scale of hours, not seconds.
      // Two minutes keeps a returning tab honest without polling the API for
      // data that has not moved.
      staleTime: 120_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        const status = (error as { status?: number })?.status
        // Never retry an auth or validation failure — it will fail identically.
        if (status && status < 500) return false
        return failureCount < 2
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Vite rewrites this at build time; it is '/' in development and
          '/portal' when built for a subfolder. Without it every route below
          would resolve one level too high. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <PortalAuthProvider>
          <App />
        </PortalAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
